export default __webpack_public_path__ + "static/media/hightower-logo.96de359f.png";